<div class="main-container background-img">
  <div class="containter-fluid pl-3 pl-md-5 pt-3">
    <div class="row">
      <div class="col col-md-8 offset-md-1">
        <img [src]="logo | translate" class="ipc-logo" alt="ipc logo">
      </div>
      <div class="col col-md-2 col-lang my-auto">
        <label for="">
          <button class="lang-btn" (click)="changeLang('en')">EN</button>
          <button class="lang-btn" (click)="changeLang('fr')">FR</button>
        </label>
      </div>
    </div>
  </div>
  <div class="container mt-5 mb-5">
    <div class="row bg-white pt-5">
      <div class="col-md-2 pr-0 offset-md-1">
        <h3 class="pr-2">Search Name:</h3>
      </div>
      <div class="col-md-2">
        <input type="text" [(ngModel)]='listFilter'>
      </div>
    </div>
    <div class="row bg-white">
      <div class="col col-md-10 offset-md-1 mb-5 table-responsive">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Advisor Name</th>
              <th>Page</th>
              <th>Bilingual</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let advisor of filterAdvisors">
              <td>{{advisor.name | uppercase}}</td>
              <a [routerLink]="['/',this.translate.currentLang,'advisor', advisor.name]">
                <td>{{advisor.page}}</td>
              </a>
              <td>{{advisor.MultiLang}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>